import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import dayjs from 'dayjs';
var STATUS_TEXT_MAP = {
  pending: '审批中',
  approved: '已通过',
  rejected: '已拒绝',
  returned: '已退回'
};
var STATUS_TAG_MAP = {
  pending: 'primary',
  approved: 'success',
  rejected: 'danger',
  returned: 'warning'
};
export default {
  name: 'ApprovalMessageCard',
  props: {
    card: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    normalizedCard: function normalizedCard() {
      var extra = this.card.extra || {};
      var fallbackLink = this.card.deepLink || extra.deepLink || "/workflow/detail/".concat(extra.processId || '');
      return {
        type: this.card.type || this.card.cardType || 'approval',
        title: this.card.title || '审批',
        summary: this.card.summary || extra.actionText || '',
        status: this.card.status || 'pending',
        actions: Array.isArray(this.card.actions) ? this.card.actions : [],
        extra: {
          processId: this.card.processId || extra.processId,
          bizId: this.card.bizId || extra.bizId,
          bizType: this.card.bizType || extra.bizType,
          initiatorName: this.card.initiatorName || extra.initiatorName,
          currentHandler: this.card.currentHandler || extra.currentHandler,
          actionText: this.card.actionText || extra.actionText,
          createdTime: this.card.createdTime || extra.createdTime,
          deepLink: fallbackLink
        }
      };
    },
    statusText: function statusText() {
      return STATUS_TEXT_MAP[this.normalizedCard.status] || '未知';
    },
    statusTagType: function statusTagType() {
      return STATUS_TAG_MAP[this.normalizedCard.status] || 'info';
    },
    actionText: function actionText() {
      var primaryAction = this.normalizedCard.actions.find(function (action) {
        return action && action.deepLink;
      });
      return (primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.text) || '查看详情';
    }
  },
  methods: {
    formatTime: function formatTime(value) {
      var time = dayjs(value);
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : value;
    }
  }
};